export default "__VITE_ASSET__oneMrdp8__"